<script setup lang="ts">
import {Backing} from "@/backing/interfaces/backing";
import BackingReportCard from "@/backing/components/reports/BackingReportCard.vue";
import {InterviewInstance} from "@/interview/interfaces/interview";
import InterviewInstanceService from "@/interview/services/InterviewInstanceService";
import {computed} from "vue";

const props = defineProps<{
    backing: Backing;
    consumerKey: string;
    interviewInstances: Omit<InterviewInstance, 'interview'>[] | null;
}>();

const hasFinishedInstance = computed(() => {
    return props.interviewInstances?.some(instance => InterviewInstanceService.isInterviewFinished(instance)) ?? false;
});

const latestInstance = computed(() => {
    if (!props.interviewInstances?.length) {
        return null;
    }

    return [...props.interviewInstances ?? []].sort((a, b) => {
        return new Date(b.started_at).getTime() - new Date(a.started_at).getTime();
    })[0] || null;
});
</script>

<template>
  <div class="flex gap-4 flex-wrap flex-col md:flex-row">
    <BackingReportCard
      v-if="backing.pharmacist_report_engine"
      :configuration="backing.pharmacist_report_engine"
      class="flex-1"
      :consumer-key="consumerKey"
      :backing="backing"
      type="pharmacist"
      :disabled="!hasFinishedInstance"
      :last-instance-date="latestInstance ? new Date(latestInstance.started_at) : null"
    />
    <BackingReportCard
      v-if="backing.patient_report_engine"
      :configuration="backing.patient_report_engine"
      class="flex-1"
      :backing="backing"
      :consumer-key="consumerKey"
      type="patient"
      :disabled="!interviewInstances?.length"
      :last-instance-date="latestInstance ? new Date(latestInstance.started_at) : null"
    />
  </div>
</template>

<style scoped>

</style>
